import {useState} from "react"
import {
	Button,
	Stack,
	// List,
	// ListItem,
	TextField,
	Box, Chip, Typography
} from "@mui/material"
import axios from "axios"
import {useSnackbar} from "notistack"
import {selectSelectedArticles, clearSelectedArticles} from "../../reducers/selectedArticlesSlice"
import {useDispatch, useSelector} from "react-redux"
import {selectUser} from "../../reducers/userSlice"
import {
	addUserToSelectedUsers,
	removeUserFromSelectedUsers, resetUserSearch,
	selectSelectedUsers
} from "../../reducers/userSearchSlice"
import {UserLookup, LookupTypes} from "../../utils/UserLookup"
import {closeShareArticlesModal, selectShareArticlesModal} from "../../reducers/dashboardModalControlSlice"
import {DashboardModal} from "./DashboardModal"
import {useWorkspaceContext} from "../../pages/Dashboard"

export default function ShareArticleModal() {
	const dispatch = useDispatch()
	const {workspaceId} = useWorkspaceContext()
	const [message, setMessage] = useState("")
	const {enqueueSnackbar} = useSnackbar()
	const userSelection = useSelector(selectSelectedUsers)
	const sendingUser = useSelector(selectUser)
	const selectedArticles = useSelector((state) => selectSelectedArticles(state, workspaceId))
	const articleCount = Object.keys(selectedArticles).length
	const isOpen = useSelector(selectShareArticlesModal)

	const sendCitation = () => {
		// Construct the batch payload
		const notificationsData = userSelection.map(user => ({
			message: message,
			type: "article_share",
			userId: user.id,
			sendingUserId: sendingUser.id,
			sharedArticles: Object.keys(selectedArticles),
			sendingWorkspaceId: workspaceId
		}))

		// Send the batch request
		axios.post("/api/notifications/batch", notificationsData)
			// eslint-disable-next-line no-unused-vars
			.then(response => {
				enqueueSnackbar(
					"Successfully shared the articles.",
					{
						variant: "success",
						autoHideDuration: 3000
					}
				)
				handleCloseModal()
			})
			.catch(error => {
				console.error("Error while sharing articles: ", error)
				enqueueSnackbar(
					"Error while sharing. Please try again.",
					{
						variant: "error",
						autoHideDuration: 3000
					}
				)
			})
	}

	const handleCloseModal = () => {
		setMessage("")
		dispatch(resetUserSearch())
		dispatch(closeShareArticlesModal())
		dispatch(clearSelectedArticles(workspaceId))  // Clear the selected articles from the state
	}

	return (
		<DashboardModal
			open={isOpen}
			setClose={handleCloseModal}
			title={`Add recipients - Sharing ${articleCount} articles`}
		>
			<Box sx={{
				display: "flex",
				flexDirection: "column",
				gap: "0.5rem",
				width: "60vw",
				minHeight: "50vh",
				justifyContent: "space-evenly",
			}}>
				<UserLookup
					lookupType={LookupTypes.GLOBAL}
					onSelectUserCB={(user) => dispatch(addUserToSelectedUsers(user))}
					showTier={false}
				/>
				<Box
					sx={{
						display: "inline-flex",
						flexDirection: "row",
						gap: "0.5rem",
						flexWrap: "wrap",
						alignItems: "center",
						minHeight: "2rem",
						//marginBottom: "0.5rem",
					}}
				>
					<Typography variant="tunedSubtitle3Bold">
						Recipients:
					</Typography>
					{userSelection.length > 0 && userSelection.map((user) => (
						<Chip
							key={user.id + "userselection"}
							label={`${user.firstName} ${user.lastName}`}
							onDelete={() => dispatch(removeUserFromSelectedUsers(user))}
							variant={"outlined"}
							sx={{
								padding: 0,
								width: "auto",
							}}
						/>
					))}

				</Box>
				<Box>
					<TextField
						onKeyDown={(e) => e.stopPropagation()}
						fullWidth
						label="Message"
						variant="outlined"
						value={message}
						multiline
						minRows={3}
						maxRows={4}
						onChange={(e) => setMessage(e.target.value)}
					/>
				</Box>
			</Box>
			<Stack spacing={4} direction="row" justifyContent="end" mt={"1rem"}>
				<Button
					variant={"outlined"}
					color="primary"
					onClick={handleCloseModal}
				>
					Cancel
				</Button>

				<Button
					variant="contained"
					color="primary"
					disabled={userSelection.length < 1}
					onClick={() => {
						sendCitation()
					}}>
					Share
				</Button>
			</Stack>
		</DashboardModal>
	)
}